import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { JobInterviewTemplate } from './job-evaluation-forms-store.types';

@Injectable({
  providedIn: 'root',
})
export class JobEvaluationFormsHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetchOne$(jobId: number): Observable<{ offerInterviewTemplates: JobInterviewTemplate[] }> {
    return this.httpApi.get(`/offers/${jobId}/interview_templates`);
  }
}
